import type { ResourcesConfig } from "aws-amplify";

/**
 * Amplify に渡す設定を環境変数から組み立てる。
 *
 * Amplify CLI を使わないため、CLI の生成する設定ファイルは持たない。
 * 認証以外（GraphQL / Storage）は接続先を持たせない。
 */
export const buildAmplifyConfig = (): ResourcesConfig => {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    throw new Error(
      "VITE_COGNITO_USER_POOL_ID と VITE_COGNITO_USER_POOL_CLIENT_ID を .env に設定してください"
    );
  }

  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        // ユーザープールのポリシーと揃える。渡さないと Authenticator の
        // 入力検証が働かず、サーバ側の英語エラーで弾かれる
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  };
};
